import { ContentPage } from "../components/layout/ContentPage";
import { getLegalCopy } from "../data/legalPages";
import { useTranslation } from "../i18n";
import { createLocalizedMeta } from "../utils/routeMeta";

export const meta = createLocalizedMeta({
	title: locale => getLegalCopy(locale).terms.metaTitle,
	description: locale => getLegalCopy(locale).terms.metaDescription,
	path: "/terms",
});

export default function TermsPage() {
	const { locale } = useTranslation();
	const copy = getLegalCopy(locale).terms;

	return (
		<ContentPage title={copy.title} subtitle={copy.subtitle}>
			{copy.sections.map(section => (
				<section key={section.title}>
					<h2>{section.title}</h2>
					<p>{section.body}</p>
				</section>
			))}
		</ContentPage>
	);
}
